import { AddBox } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import {
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import BusinessIcon from "@mui/icons-material/Business";
import NewCompanyContact from "../CompaniesCommunication/NewCompanyContact";
import { useState } from "react";
import { CommunicationTypeEnum } from "../../../store/services/communicationService";
import UpdateCommunicationDialog from "./UpdateCommunicationDialog";

interface AddCommunicationButtonProps {
  isCompany?: boolean;
  customerNo: number;
  contactPersonNo?: number;
}

export const AddCommunicationButton = ({
  isCompany = false,
  customerNo,
  contactPersonNo,
}: AddCommunicationButtonProps) => {
  const [communicationType, setCommunicationType] =
    useState<CommunicationTypeEnum>();

  const communicationTypes = [
    {
      type: CommunicationTypeEnum.Mobiltelefon,
      label: "Mobil",
      Icon: SmartphoneIcon,
    },
    { type: CommunicationTypeEnum.Epost, label: "E-post", Icon: EmailIcon },
    {
      type: CommunicationTypeEnum.Telefon,
      label: "Telefon",
      Icon: CallIcon,
    },
  ];

  if (isCompany) {
    communicationTypes.push({
      type: CommunicationTypeEnum.CompanyContact,
      label: "Företagskontakt",
      Icon: BusinessIcon,
    });
  }

  if (communicationTypes.length === 0) return null;
  return (
    <>
      <PopupState variant="popover" popupId="add-communication">
        {(popupState) => (
          <>
            <ListItemIcon sx={{ minWidth: 25 }}>
              <AddBox
                fontSize="small"
                {...bindTrigger(popupState)}
                sx={{ cursor: "pointer" }}
              />
            </ListItemIcon>

            <Menu {...bindMenu(popupState)}>
              <Box>
                {communicationTypes.map(({ type, label, Icon }) => (
                  <MenuItem
                    key={type}
                    onClick={() => {
                      setCommunicationType(type);
                      popupState.close();
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 35 }}>
                      <Icon fontSize="small" />
                    </ListItemIcon>
                    <Typography variant="inherit">{label}</Typography>
                  </MenuItem>
                ))}

                <Divider />
                <MenuItem onClick={popupState.close}>
                  <ListItemIcon sx={{ minWidth: 35 }}>
                    <CloseIcon fontSize="small" />
                  </ListItemIcon>
                  <Typography variant="inherit">Stäng</Typography>
                </MenuItem>
              </Box>
            </Menu>
          </>
        )}
      </PopupState>
      {communicationType == CommunicationTypeEnum.CompanyContact ? (
        <NewCompanyContact
          open={communicationType !== undefined}
          handleClose={() => setCommunicationType(undefined)}
          customerNo={customerNo}
        />
      ) : communicationType !== undefined ? (
        <UpdateCommunicationDialog
          customerId={customerNo}
          type={communicationType}
          onClose={() => setCommunicationType(undefined)}
          contactPersonNo={contactPersonNo}
        />
      ) : null}
    </>
  );
};
